import React                      from 'react';
import { observer }               from 'mobx-react';
import { Button }                 from 'antd';
import { Popconfirm }             from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';
import { Empty }                  from 'antd';
import { List }                   from 'antd';
import { Skeleton }               from 'antd';
import { messageSuccessIntl }     from 'utils/messageIntl';
import { AppForm }                from 'components/App/AppForm';
import ContactForm                from 'forms/ContactForm';
import FormattedMessageWrapper    from 'components/App/FormattedMessageWrapper';
import ContactModel               from 'models/ContactModel';
import { Collection }             from '@mathquis/modelx';

interface ProviderDashboardContactsTableProps {
  contactCollection: Collection<ContactModel>;
}

@observer
class ProviderDashboardContactsTable extends React.Component<ProviderDashboardContactsTableProps> {
  public render() {
    const { contactCollection } = this.props;

    if (!contactCollection.length) {
      return <Empty description={<FormattedMessageWrapper id="Aucun contact." />} />;
    }

    return (
      <List
        dataSource={contactCollection.models}
        loading={!contactCollection.isLoaded || contactCollection.isLoading}
        renderItem={(contact: ContactModel) => (
          <List.Item
            actions={[
              <Button
                htmlType="button"
                key="edit"
                onClick={event => {
                  event.stopPropagation();
                  AppForm.open(ContactForm, {
                    model: contact,
                    onSuccess: () => contactCollection.list(),
                  }, {
                    title: <FormattedMessageWrapper id="Modifier un contact" />,
                  });
                }}
              >
                <FormattedMessageWrapper id="Modifier" />
              </Button>,

              <Popconfirm
                cancelText={<FormattedMessageWrapper id="Non" />}
                icon={<QuestionCircleOutlined style={{ color: '#e74c3c' }} />}
                key="popconfirm"
                okText={<FormattedMessageWrapper id="Oui" />}
                onCancel={event => event?.stopPropagation()}
                onConfirm={async (event) => {
                  event?.stopPropagation();

                  try {
                    await contact.destroy();
                    messageSuccessIntl('Contact supprimé !');
                    contactCollection.list();
                  } catch {
                    messageSuccessIntl("Erreur lors de la suppression");
                  }
                }}
                placement="left"
                title={
                  <FormattedMessageWrapper id="Êtes-vous sûr de vouloir supprimer ce contact ?" />
                }
              >
                <Button
                  htmlType="button"
                  onClick={event => {
                    event.stopPropagation();
                  }}
                >
                  <FormattedMessageWrapper id="Supprimer" />
                </Button>
              </Popconfirm>,
            ]}
          >
            <Skeleton active avatar={false} loading={contact.isLoading} title={false}>
              <List.Item.Meta
                description={
                  <div>
                    <div>{contact.get('phone')}</div>
                    <div>{contact.get('company')}</div>
                  </div>
                }
                title={`${contact.get('lastname')} ${contact.get('firstname')}`}
              />
            </Skeleton>
          </List.Item>
        )}
      />
    );
  }
}

export default ProviderDashboardContactsTable;
